module.exports = __webpack_public_path__ + "img/no_chat_messages.bbdca4b9.svg";